import { ThemeMode } from 'types/config';

// Shared `info` palette ramp used by every preset theme (default + theme1–8). A cold blue-teal
// (MUI-default-style) replacing the various Ant/teal ramps that read too green.
//
// Order: [lighter, light, main, dark, darker]. Like every other palette color, the DARK ramp is
// *reversed* — `lighter` is the darkest shade — so components that paint `info.lighter`/`info.light`
// as a background (Chip/Alert/Badge light variants) get a dark fill in dark mode, not a bright one.
// `main` is kept identical across modes so contained buttons / dots / tabs stay consistent and
// legible against their white text.
export const INFO_COLORS_LIGHT = ['#e1f5fe', '#03a9f4', '#0288d1', '#01579b', '#014377'];
export const INFO_COLORS_DARK = ['#16242e', '#22506b', '#0288d1', '#4fc3f7', '#e1f5fe'];

export const getInfoColors = (mode: ThemeMode) =>
  mode === ThemeMode.DARK ? INFO_COLORS_DARK : INFO_COLORS_LIGHT;
